/**
 * Vesper Block & Report Service (Shared, Sprint 2)
 */

import apiClient from './api.client';

export interface BlockedRow {
  blockerId: string;
  blockedId: string;
  createdAt: string;
  /** Display info joined server-side so the Settings list doesn't need extra round-trips. */
  blockedDisplayName?: string | null;
  blockedAvatarUrl?: string | null;
}

export async function blockUser(targetId: string): Promise<void> {
  await apiClient.post(`/users/${targetId}/block`);
}

export async function unblockUser(targetId: string): Promise<void> {
  await apiClient.delete(`/users/${targetId}/block`);
}

export async function listBlocked(): Promise<BlockedRow[]> {
  const res = await apiClient.get<{ data: { blocked: BlockedRow[] } }>('/users/me/blocked');
  return res.data.data.blocked;
}

export async function reportUser(
  targetId: string,
  reason: string,
  details?: string,
): Promise<void> {
  await apiClient.post(`/users/${targetId}/report`, { reason, details });
}
